// extracted by mini-css-extract-plugin
export default {"leetcode":"LeetCode_leetcode__OMCNx","videoGrid":"LeetCode_videoGrid__eSPbO","videoItem":"LeetCode_videoItem__UiGdN","videoWrapper":"LeetCode_videoWrapper__cIkbx"};